import script from "./AnamnesisManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AnamnesisManagement.vue?vue&type=script&setup=true&lang=js"

import "./AnamnesisManagement.vue?vue&type=style&index=0&id=09f5dc8a&lang=css"

const __exports__ = script;

export default __exports__